import { useState, useEffect, useRef } from "react";
import { API_URL, scroll, getValFromLS } from "../../helpers";

import Hdg from "../../components/Hdg";
import Alert from "../../components/Alert";
import Input from "../../components/Input";

import Nav from "../Nav";

import Table from "./Table";
import Form from "./Form";

const Addons = () => {
  const [user, setUser] = useState({});
  const [details, setDetails] = useState({});
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const formElement = useRef();

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    setAlert({
      type: "working",
      text: "",
    });

    const token = getValFromLS("vtoUserToken")
      ? getValFromLS("vtoUserToken")
      : "";
    const url = new URL(`${API_URL}/admin/addonsInit`);
    const params = {
      token,
    };
    url.search = new URLSearchParams(params);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setUser({ ...json.user });
        setAlert({});
        scroll();
      } else {
        setAlert({
          type: json.resp === 2 ? "notice" : "error",
          text: json.text,
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    formElement.current.registrationId.disabled = true;

    const url = new URL(`${API_URL}/admin/addons`);
    let formData = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("token", getValFromLS("vtoUserToken"));

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });
      const json = await response.json();

      if (json && json.resp === 1) {
        formElement.current.registrationId.disabled = false;
        setDetails({ ...json });
      } else {
        formElement.current.registrationId.disabled = false;
        setErrors(json.fields);
      }
    } catch (error) {
      formElement.current.registrationId.disabled = false;
      setErrors(["registrationId"]);
    }
  };

  const handleSuccess = async () => {
    formElement.current.registrationId.disabled = true;

    const url = new URL(`${API_URL}/admin/addons`);
    let formData = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("token", getValFromLS("vtoUserToken"));

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });
      const json = await response.json();

      if (json && json.resp === 1) {
        formElement.current.registrationId.disabled = false;
        setDetails({ ...json });
      } else {
        formElement.current.registrationId.disabled = false;
        setErrors(json.fields);
      }
    } catch (error) {
      formElement.current.registrationId.disabled = false;
      setErrors(["registrationId"]);
    }
  };

  return (
    <>
      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <>
          <div id="left-column">
            <Hdg section="Admin Registration Addons" />

            <p>
              Use this form to add line item addons to a sponsor registration
              and invoice.
            </p>

            <div className="spacer"></div>

            <form
              ref={formElement}
              method="post"
              action="/"
              onSubmit={(e) => handleSubmit(e)}
              className="well"
              style={{ paddingBottom: "10px" }}
            >
              <div className="form-group">
                <Input
                  name="registrationId"
                  label="Registration ID"
                  reqd={true}
                  value={""}
                  update={handleUpdate}
                  errors={errors}
                  note=""
                />

                <div className="empty" />
              </div>
            </form>

            {details.id && <Table details={details} />}
            {details.id && (
              <Form registrationId={details.id} success={handleSuccess} />
            )}

            <div className="spacer"></div>
          </div>

          <div id="right-column">
            <Nav on={0} user={user} />
          </div>
        </>
      )}
    </>
  );
};

export default Addons;
